import { yodeck } from './yodeck.jsx';
import { screencloud } from './screencloud.jsx';
import { novisign } from './novisign.jsx';
import { optisigns } from './optisigns.jsx';
import { withDutchVs } from './dutch.js';
import { withJapaneseVs } from './japanese.js';

const baseVs = [yodeck, screencloud, novisign, optisigns];

export const vs = baseVs
  .map(withDutchVs)
  .map(withJapaneseVs)
  .sort((a, b) => b.id - a.id);

export const getVsBySlug = (slug) =>
  vs.find((item) => {
    if (typeof item.slug === 'string') return item.slug === slug;
    return Object.values(item.slug).includes(slug);
  });

export const getVsById = getVsBySlug;
